import React from "react";
import { StoryblokComponent, storyblokEditable } from "@storyblok/react";
import {
  ProductModel,
  SectorModel,
  ShowcasePanelModel,
} from "./ShowcasePanelModel";

import "./ShowcasePanel.css";
import Utils from "../../core/Utils/Utils";

const ShowcasePanel: React.FC<{ blok: ShowcasePanelModel }> = ({ blok }) => {
  const entity = blok.entity[0].content;
  const isProductEntity = (): boolean => {
    return (entity as ProductModel).productName !== undefined;
  };
  const isVideo = blok.media?.filename?.endsWith(".mp4");

  const getName = (): string => {
    if (isProductEntity()) {
      return (entity as ProductModel).productName;
    }
    return (entity as SectorModel).sectorName;
  };
  const getTagline = (): string => {
    if (isProductEntity()) {
      return (entity as ProductModel).tagLine;
    }
    return (entity as SectorModel).sectorTagline;
  };
  const getDescription = (): string => {
    if (isProductEntity()) {
      return (entity as ProductModel).description;
    }
    return (entity as SectorModel).sectorDescription;
  };

  return (
    <div
      {...storyblokEditable(blok)}
      className={`showcase-panel ${blok.display}`}
    >
      {isVideo && (
        <video
          autoPlay
          loop
          muted
          playsInline
          src={Utils.getCacheUrl(blok.media?.filename)}
          data-object-fit="cover"
          onError={(e) => Utils.handleVideoError(e, blok.media.filename)}
        ></video>
      )}
      {!isVideo && blok.media?.filename && (
        <img
          src={Utils.getCacheUrl(blok.media.filename)}
          alt=""
          onError={(e) => Utils.handleImageError(e, blok.media?.filename)}
        />
      )}
      <div className="container">
        <div className="showcase-content">
          <div className="showcase-name">{getName()}</div>
          <div className="tag-line">{getTagline()}</div>
          <div className="description">{getDescription()}</div>
          <div className="showcase-buttons">
            {blok.buttons
              ? blok.buttons.map((button) => (
                  <StoryblokComponent
                    blok={button}
                    key={button._uid}
                    className="button"
                  />
                ))
              : null}
          </div>
          <div className="supported-on">
            {isProductEntity()
              ? `Supported on ${(entity as ProductModel).os?.join(", ")}`
              : " "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowcasePanel;
